export const fallbackLng = 'de';
export const languages = ['en', 'fr', 'it', 'de'];
export const defaultNS = 'common';

export type LanguageValue = (typeof languages)[number];

export function i18nOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    lng,
    fallbackLng,
    ns,
    defaultNS,
    fallbackNS: defaultNS,
    supportedLngs: languages,
  };
}

export const changeLangMessages: Record<
  LanguageValue,
  { success: string; error: string; loading: string }
> = {
  en: {
    success: 'Language has been changed!',
    error: 'Error changing language!',
    loading: 'Loading...',
  },
  fr: {
    success: 'La langue a été changée!',
    error: 'Erreur lors du changement de langue!',
    loading: 'Chargement...',
  },
  it: {
    success: 'La lingua è stata cambiata!',
    error: 'Errore nel cambio della lingua!',
    loading: 'Caricamento...',
  },
  de: {
    success: 'Sprache wurde geändert!',
    error: 'Fehler beim Ändern der Sprache!',
    loading: 'Wird geladen...',
  },
};
